import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
import { omit } from "lodash";

const useEditFilter = () => {
  return useMutation((params) => {
    const id = params.id;
    const payload = omit(params, "id");
    servicesUtils.postService(`/profile/filters/${id}/`, payload);
  });
};

export default useEditFilter;
